import { Box, Text } from '@redbubble/design-system';
import { FormattedMessage } from '@redbubble/next/intl';
import { ItemLabel } from './types';

export const SimilarDesignsSectionHeader: React.FC<{
  itemLabel: ItemLabel;
}> = ({ itemLabel }) => {
  return (
    <Box marginBottom="xs">
      <Text element="h2" type="display3">
        {itemLabel ? (
          <FormattedMessage
            defaultMessage="{labelText} you might like"
            values={{
              labelText: itemLabel,
            }}
          />
        ) : (
          <FormattedMessage defaultMessage="You might like" />
        )}
      </Text>
    </Box>
  );
};
